import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=6736c0b8&"
import script from "./MenusList.vue?vue&type=script&lang=js&"
export * from "./MenusList.vue?vue&type=script&lang=js&"
import style0 from "./MenusList.vue?vue&type=style&index=0&id=6736c0b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports